import { addToGlobalThisRet } from "@plugins";

class Notify {
    constructor(elem) {
        this.elem = elem;
        this.notifyIcon = elem.querySelector(".js-notify-icon");
        this.notifyList = elem.querySelector(".js-notify-list");

        this.notifyIcon.addEventListener("click", () => {
            this.notifyList.classList.toggle("hidden");
        });

        document.addEventListener("click", (e) => {
            if (!this.elem.contains(e.target)) {
                this.notifyList.classList.add("hidden");
            }
        });
    }
}

function initNotify() {
    const notify = document.querySelectorAll(".js-notify");

    if (notify) {
        notify.forEach((item) => {
            new Notify(item);
        });
    }
}

window.addEventListener("load", () => {
    initNotify();
});

addToGlobalThisRet(initNotify, "initNotify");
